var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mt-2 ml-2 mr-2"},[_c('FVendorTable',{ref:"refTabVendorClick"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }